jQuery(document).ready(function () {
    setTimeout(function () {
        jQuery('.wm-header__carousel').owlCarousel({
            loop: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 5000,
            lazyLoad: true,
            animateOut: 'fadeOut',
            mouseDrag: false,
            touchDrag: false
        });
    }, 200);
    jQuery('a[href*="find-us"]').click(function () {
        setTimeout(function () {
            jQuery('.wm-form').find('input[name="your-name"]').focus();
        }, 1600);
    });
});
